// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"53638c595d43b65a","8973":"d473d9b5f7d1e21d"}[chunkId] + ".css";
};